const pageFromPageView = (pageView) => Promise.resolve(pageView.object).then((objectProperties) => ({
    id: objectProperties.id,
    type: (objectProperties.type || 'Page'),
    url: objectProperties.url || window.location.href,
}));
export { pageFromPageView };
//# sourceMappingURL=page-from-page-view.js.map